export enum LeoStatus {
  CLOSED = 'closed',
  OPENED = 'opened',
  MINIMIZED = 'minimized',
  SUGGESTIONS = 'suggestions',
}
